import { render, staticRenderFns } from "./BigPowerSwitcher.vue?vue&type=template&id=2a5d1e74&scoped=true"
import script from "./BigPowerSwitcher.vue?vue&type=script&lang=js"
export * from "./BigPowerSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BigPowerSwitcher.vue?vue&type=style&index=0&id=2a5d1e74&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5d1e74",
  null
  
)

export default component.exports